<!-- `shelf--binder` is load-bearing. The hosted editor's own sheet keys its
     single-scroller layout off it with :host-context(.shelf--binder). -->
@if (active.price()) {
<div
  class="binder shelf--binder"
  data-readiness-target="shelf"
  data-readiness-target-alt="shelves"
>
  <div class="binder__editor-scroll">
    @if (copySources().length) {
    <div class="binder__copy-row">
      <span class="binder__copy-row-label">
        <mat-icon aria-hidden="true">content_paste</mat-icon>
        Copy shelves from
      </span>
      <div class="binder__copy-chips">
        @for (source of copySources(); track source.entry.id) {
        <button
          type="button"
          class="binder__copy-chip"
          [title]="
            'Add ' +
            source.gain +
            ' shelves from ' +
            source.entry.title +
            ' (' +
            source.entry.id +
            ')'
          "
          (click)="copyShelvesFrom(source.entry.id)"
        >
          {{ source.entry.title }}
          <code class="binder__copy-chip-id">{{ source.entry.id }}</code>
          @if (amountOf(source.entry); as amount) {
          <span class="text-xs enr-text-surface">{{ amount }}</span>
          }
          <span class="binder__copy-chip-n" aria-hidden="true">
            +{{ source.gain }}
          </span>
        </button>
        }
      </div>
    </div>
    }

    <app-enrichment-price-shelf
      [boundShelves]="boundShelves()"
      [channel]="channel()"
      (shelfAdd)="onPriceShelfAdd($event)"
      (shelfRemove)="onPriceShelfRemove($event)"
      (shelvesAdd)="onPriceShelvesAdd($event)"
      (shelvesRemove)="onPriceShelvesRemove($event)"
    ></app-enrichment-price-shelf>
  </div>
</div>
}
